import { useGrowthBook } from '@growthbook/growthbook-react';
import { useIsPrescriberFlow } from '@web-app/utils/feature-flags/prescriber-flow';

import { useGrowthBookReady } from './useGrowthBookReady';
import { useIsMedicalDoctor } from './useIsMedicalDoctor';

/** Wait for the prescriber-flow inputs before allowing reminders to auto-open. */
export const usePreCallRemindersEnabled = (
  appointmentTypeId: string | undefined,
): boolean => {
  const growthbook = useGrowthBook();
  const isGrowthBookReady = useGrowthBookReady();
  const { isMedicalDoctor, isLoading, isError } = useIsMedicalDoctor();
  const isPrescriberFlow = useIsPrescriberFlow();
  const attributes = growthbook?.getAttributes();

  // The provider query can finish before the effects that sync its result and
  // the appointment type to GrowthBook. Wait for that evaluation too.
  return (
    isGrowthBookReady &&
    !isLoading &&
    !isError &&
    attributes?.isMedicalDoctor === isMedicalDoctor &&
    !!appointmentTypeId &&
    attributes?.appointmentTypeId === appointmentTypeId &&
    !isPrescriberFlow
  );
};
